export const Facets = (function () {
	'use strict';

	function init() {
		facetTooltps();
        facetSliderTooltips();

        // Click Handler - Woo Commerce Product Grid Sidebar Facet
        document.body.addEventListener('click', function () {
            var activeFacetTooltip = document.querySelector('.products-sidebar__facet-tooltip.show');
            var activeProductTooltip = document.querySelector('.product-loop__tooltip.show');

            if (activeFacetTooltip) {
                activeFacetTooltip.classList.remove('show');
            }

            if (activeProductTooltip) {
                activeProductTooltip.classList.remove('show');
            }
        });

        $(document).on('facetwp-loaded', function () {
            if (FWP.loaded) {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
	}

	function facetTooltps() {
        var tooltipToggles = document.querySelectorAll('.products-sidebar__tooltip-toggle');
        var tooltips = document.querySelectorAll('.products-sidebar__facet-tooltip');

        tooltipToggles.forEach(function (tooltipToggle) {

            tooltipToggle.addEventListener('click', function (event) {
                activeTooltip = this.querySelector('.products-sidebar__facet-tooltip');
                event.stopPropagation()

                tooltips.forEach(function (inactiveTooltip) {
                    if (activeTooltip !== inactiveTooltip) {
                        inactiveTooltip.classList.remove('show');
                    }
                });

                activeTooltip.classList.toggle('show');
            });
        });
    }

    function facetSliderTooltips() {
        if ('object' != typeof FWP) {
            return;
        }

        if (FWP) {
            FWP.hooks.addFilter('facetwp/set_options/slider', function (opts, facet) {
                opts.tooltips = [true, true];
                return opts;
            });
        }
    };

	return {
		init: init,
	};
})();
